// import Swiper, { Autoplay, EffectFade, Navigation, Pagination, Lazy } from "swiper";
import Swiper from 'swiper/bundle';

let possibleSliders = [
	".js-slider-banner",
	".js-slider-offer",
	".js-slider-offer-gallery-vertical",
	".js-slider-offer-gallery",
	".js-slider-new-offer"
];
// (async () => {
window.addEventListener('load', () => {
	if (possibleSliders.some((x) => document.querySelector(x))) {
		// let Swiper = await import("swiper");
		// Swiper = Swiper.default
		// Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Lazy])

		const sliderBanner = new Swiper(".js-slider-banner .swiper-container", {
			// modules: [ Autoplay, EffectFade, Pagination, Lazy ],
			autoplay: {
				delay: 7000,
			},
			speed: 1000,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			pagination: {
				el: ".swiper-pagination",
				type: "bullets",
				clickable: true,
			},
			lazy: {
				enabled: true,
				loadOnTransitionStart: true,
				loadPrevNext: false,
				preloaderClass: 'swiper-lazy-preloader',
			},
		});

		const sliderOffer = new Swiper(".js-slider-offer .swiper-container", {
			// modules: [ Autoplay, EffectFade ],
			autoplay: {
				delay: 7000,
			},
			speed: 1000,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
		});

		const offerSliderNavDOM = document.querySelectorAll('.js-offer-slider-nav');
		window.changeOfferSlide = (index) => {
			if(offerSliderNavDOM){
				offerSliderNavDOM.forEach(x => {
					x.classList.remove('is-active')
				})
				offerSliderNavDOM[index].classList.add('is-active')
			}
			sliderOffer.slideTo(index)
		}


		const sliderNewOffer = new Swiper(".js-slider-new-offer", {
			// modules: [ Autoplay, Navigation ],
			autoplay: {
				delay: 7000,
			},
			speed: 1000,
			breakpoints: {
				320: {
						slidesPerView: 1,
						spaceBetween: 16
				},
				600: {
						slidesPerView: 2,
						spaceBetween: 16
				},
				991: {
						slidesPerView: 3,
						spaceBetween: 16
				},
				1240: {
						slidesPerView: 3,
						spaceBetween: 16
				},
				1600: {
						slidesPerView: 4,
						spaceBetween: 16
				}
			},
			navigation: {
				nextEl: '.js-slider-new-offer .js-swiper-nav-next',
				prevEl: '.js-slider-new-offer .js-swiper-nav-prev',
			},
		});
		// const sliderNewOffer = new Swiper(".js-slider-new-offer .swiper-container", {
		// 	autoplay: {
		// 		delay: 3000,
		// 	},
		// 	speed: 1000,
		// 	effect: 'fade',
		// 	fadeEffect: {
		// 		crossFade: true
		// 	},
		// });

		const newOfferSliderNavDOM = document.querySelectorAll('.js-new-offer-slider-nav');
		const newOfferContainersDOM = document.querySelectorAll('.js-offer-containers');
		window.changeNewOfferSlide = (index) => {
			if(newOfferSliderNavDOM && newOfferContainersDOM){
				newOfferSliderNavDOM.forEach(x => {
					x.classList.remove('is-active')
				})
				newOfferContainersDOM.forEach(x => {
					x.classList.add('hidden')
				})
				newOfferSliderNavDOM[index].classList.add('is-active')
				newOfferContainersDOM[index].classList.remove('hidden')
			}
		}
		if(newOfferSliderNavDOM && newOfferSliderNavDOM.length > 0 && newOfferContainersDOM) changeNewOfferSlide(0)

		/* -------------------------------------------------------------------------- */
		/*                                product page                                */
		/* -------------------------------------------------------------------------- */
		const sliderOfferThumbnails = new Swiper(".js-slider-offer-gallery-thumbnails .swiper-container", {
			// modules: [ Autoplay ],
			autoplay: {
				delay: 7000,
			},
			speed: 1000,
			slidesPerView: 3,
			spaceBetween: 10,
			
			breakpoints: {
				1280: {
					direction: 'vertical'
				}
			}
			// centeredSlides: true,
		});

		const offerThumbnailsWrapperDOM = document.querySelector('.js-slider-offer-gallery-thumbnails-2');
		if(offerThumbnailsWrapperDOM){
			setTimeout(() => {
				const arr = offerThumbnailsWrapperDOM.getAttribute('data-addclass').split(' ')
				arr.forEach(str => {
					if (str) offerThumbnailsWrapperDOM.classList.add(str);
				})
			}, 1000);
		}

		const sliderOfferThumbnails2 = new Swiper(".js-slider-offer-gallery-thumbnails-2 .swiper-container", {
			// modules: [ Autoplay ],
			autoplay: {
				delay: 7000,
			},
			speed: 1000,
			slidesPerView: 'auto',
			// slidesPerView: 2,
			spaceBetween: 10,
			// breakpoints: {
			// 	640: {
			// 		slidesPerView: 3,
			// 	},
			// 	768: {
			// 		slidesPerView: 4,
			// 	},
			// 	1024: {
			// 		slidesPerView: 6,
			// 	},
			// 	1280: {
			// 		slidesPerView: 7,
			// 	},
			// 	1440: {
			// 		slidesPerView: 8,
			// 	},
			// 	1670: {
			// 		slidesPerView: 9,
			// 	}
			// },
			// centeredSlides: true,
		});

		const sliderOfferGallery2 = new Swiper(".js-slider-offer-gallery .swiper-container", {
			// modules: [ Navigation ],
			spaceBetween: 25,
			simulateTouch: false,
			speed: 1000,
			navigation: {
				nextEl: '.js-swiper-nav-next',
				prevEl: '.js-swiper-nav-prev',
			},
		});

		const offerGallerySliderNavDOM = document.querySelectorAll('.js-offer-gallery-slider-nav');
		window.changeOfferGallerySlide = (index) => {
			sliderOfferGallery2.slideTo(index)
		}

		sliderOfferGallery2.on('slideChange', function(){
			if(document.querySelector('.js-slider-offer-gallery-thumbnails')) sliderOfferThumbnails.slideTo(sliderOfferGallery2.activeIndex)
			if(document.querySelector('.js-slider-offer-gallery-thumbnails-2')) sliderOfferThumbnails2.slideTo(sliderOfferGallery2.activeIndex)
			offerGallerySliderNavDOM.forEach(x => {
				x.classList.remove('border-primary')
			})
			offerGallerySliderNavDOM[sliderOfferGallery2.activeIndex].classList.add('border-primary')
		})
	}
});
// })();
